export enum UserFeedManagerInviteType {
  CoManage = "CO_MANAGE",
  Transfer = "TRANSFER",
}
